import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from 'react-helmet-async';
const root = ReactDOM.createRoot(document.getElementById("root"));
const googleClientId =  process.env.REACT_APP_GOOGLE_CLIENT_ID;


const AppTree = googleClientId ? (
  <GoogleOAuthProvider clientId={googleClientId}>
    <HelmetProvider>

    <App />
    </HelmetProvider>
  </GoogleOAuthProvider>
) : (
  <App />
);

root.render(
  <React.StrictMode>
    <HelmetProvider>

    {AppTree}
    </HelmetProvider>
  </React.StrictMode>,
);
